import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'account-settings-manage-email',
		path: '/account_settings/manage_email',
		component: loadable(async () => import(/* webpackChunkName: "pages/accountSettings-manageEmail" */ './index'), {
			exportName: 'ManageEmail',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
